import { FC, ReactElement } from 'react';

import classNames from 'classnames';

import { PictureTheatre, VideoTheatre } from '../../../../../compositions';
import { ImageFormatSize, MediaItem } from '../../../../../entities/Media/Media';
import { useDeviceWidth } from '../../../../../hooks';
import { ProductMediaSlider } from '../ProductMediaSlider/ProductMediaSlider';

import './ProductMediaPresentation.scss';

interface ProductMediaPresentationProps {
    mediaItems: MediaItem[];
    className?: string;
}

export const ProductMediaPresentation: FC<ProductMediaPresentationProps> = ({
    mediaItems,
    className = '',
}): ReactElement => {
    const { isMobile } = useDeviceWidth();

    const hasOneItem = mediaItems.length === 1;
    const formatOverride = hasOneItem
        ? ImageFormatSize.original
        : ImageFormatSize.thumbnail;

    const gridClassNames = classNames('product-media-presentation__grid', {
        'product-media-presentation__grid--has-one-item': hasOneItem,
    });

    return (
        <section className={`product-media-presentation ${className}`}>
            {isMobile && (
                <ProductMediaSlider
                    mediaItems={mediaItems}
                    className="product-media-presentation__slider"
                />
            )}

            {!isMobile && (
                <ul className={gridClassNames}>
                    {mediaItems.map(mediaItem => (
                        <li key={mediaItem.id} className="product-media-presentation__item">
                            {mediaItem.image && !mediaItem.video && (
                                <PictureTheatre
                                    {...mediaItem.image}
                                    formatOverride={formatOverride}
                                    className="product-media-presentation__image"
                                />
                            )}

                            {mediaItem.video && (
                                <VideoTheatre
                                    {...mediaItem.video}
                                    playsInline={mediaItem.videoPlaysInline}
                                    poster={mediaItem.image}
                                    className="product-media-presentation__video"
                                />
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
};
